/**
 * Date formatting utilities
 *
 * @deprecated This file is deprecated. Import from DateTimeUtil.js instead.
 * This file re-exports from the centralized DateTimeUtil for backward compatibility.
 *
 * Usage:
 * import { formatDateOnly, formatDateForBlog, formatDateForSharing } from './DateTimeUtil';
 */

import {
  formatDateOnly,
  formatDateForBlog,
  formatDateForSharing,
} from "./DateTimeUtil";

/**
 * @deprecated Use formatDateOnly from DateTimeUtil.js
 * Formats a date string for display
 * @param {string} dateString - The date string from database
 * @param {Object} options - Intl.DateTimeFormat options (ignored, for backward compatibility)
 * @returns {string} Formatted date string
 */
export const formatDate = (dateString, options = {}) => {
  // Map old options to new style parameter
  if (options.month === "short") {
    return formatDateForBlog(dateString);
  }
  if (options.month === "long") {
    return formatDateForSharing(dateString);
  }
  // Default to medium style
  return formatDateOnly(dateString, "medium");
};

// Re-export from centralized utility
export { formatDateForSharing, formatDateForBlog };
